document.addEventListener('DOMContentLoaded', function() {
  const prevBtn = document.getElementById('breadcrumb_previous');
  const nextBtn = document.getElementById('breadcrumb_next');
  const crumbs = document.querySelectorAll('.crumb');
  
  if (!prevBtn || !nextBtn || !crumbs.length) return;
  
  function updateButtons() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    prevBtn.style.display = activeIndex === 0 ? 'none' : '';
    nextBtn.style.display = activeIndex === crumbs.length - 1 ? 'none' : '';
  }
  
  prevBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex > 0) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex - 1].classList.add('active');
      updateButtons();
    }
  });
  
  nextBtn.addEventListener('click', function() {
    const activeCrumb = document.querySelector('.crumb.active');
    const activeIndex = Array.from(crumbs).indexOf(activeCrumb);
    
    if (activeIndex < crumbs.length - 1) {
      activeCrumb.classList.remove('active');
      crumbs[activeIndex + 1].classList.add('active');
      updateButtons();
    }
  });
  
  updateButtons();
});